import { useWatch } from "react-hook-form";
import {
  FAUX_OVERDUE_FIELD_NAME,
  isSedDateField,
} from "@/components/tables/fields/fieldNameRules";

// a SED deadline created "without date" (faux overdue) hides executed_on and valid_until
export const useHideDateFieldForFauxOverdue = (
  entityOfTable: string | undefined,
  fieldName: string | undefined
): boolean => {
  const createWithoutDate = useWatch({ name: FAUX_OVERDUE_FIELD_NAME });
  return (
    entityOfTable === "subjectExaminationDeadline" &&
    createWithoutDate === true &&
    isSedDateField(fieldName)
  );
};
